import { createSelector } from '@reduxjs/toolkit'
import { skipGAEventAction, uploadAction } from '../../../../utils/actions'
import { selectCalculationState } from '../../../../utils/selectors'
import { createGenericSlice } from '../../../../utils/slices'
import { fieldSwitchSubAppAction, postCalculation } from '../actions/calculation.action'

export const initialState = {
  data: {
    footNotes: [],
    statusCode: 0,
    statusText: '',
    summary: [],
  },
  status: {
    isLoading: false,
    isError: false,
    msgLevel: '',
    msgHeader: '',
    msgBody: '',
  },
  virtualizedData: null,
  canSkipGAEvent: false,
  showAllModels: true,
  searchValue: '',
  sortBy: [],
}

export const outputSlice = createGenericSlice({
  name: 'output',
  initialState,
  reducers: {},
  extraReducers: (builder) =>
    builder
      .addCase(fieldSwitchSubAppAction, () => initialState)
      .addCase(skipGAEventAction, (state, action) => {
        state.canSkipGAEvent = action.payload
      })
      .addCase(uploadAction, (state) => {
        state.status = initialState.status
      })
      .addCase(postCalculation.pending, (state) => {
        state.data = initialState.data
        state.virtualizedData = initialState.virtualizedData
        state.status = {
          ...initialState.status,
          isLoading: true,
        }
      })
      .addCase(postCalculation.fulfilled, (state, action) => {
        state.data = action.payload
        state.status = initialState.status
        state.virtualizedData = initialState.virtualizedData
      })
      .addCase(postCalculation.rejected, (state, action) => {
        const { msgLevel, msgHeader, msgBody } = action.payload || {}
        state.status = {
          isLoading: false,
          isError: true,
          msgLevel: msgLevel || 'error',
          msgHeader: msgHeader || 'Network Error',
          msgBody:
            msgBody ||
            'The network connection is currently unavailable to generate results. Please try your calculations again at a later time.',
        }
      }),
})

export const outputActions = outputSlice.actions

export const selectOutputState = (state) => selectCalculationState(state)[outputSlice.name]
export const selectOutputStatus = (state) => selectOutputState(state).status
export const selectOutputVirtualizedData = (state) => selectOutputState(state).virtualizedData
export const selectOutputData = (state) => selectOutputState(state).data
export const selectOutputDataSummary = (state) => selectOutputData(state).summary
export const selectOutputDataFootNotes = (state) => selectOutputData(state).footNotes

export const selectIsValidOutput = createSelector(
  (state) => selectOutputStatus(state).isError,
  (state) => selectOutputStatus(state).isLoading,
  (isError, isLoading) => !isError && !isLoading,
)
